var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
			callback: _vm.onVisibilityChange,
			throttle: 50,
			intersection: _vm.getObserverOptions()
		}),expression:"{\n\t\t\tcallback: onVisibilityChange,\n\t\t\tthrottle: 50,\n\t\t\tintersection: getObserverOptions()\n\t\t}"}],class:_vm.classes,style:(_vm.style),attrs:{"tabindex":"0"}},[_c(_vm.blockComponent,{tag:"component",attrs:{"block":_vm.blockRef,"block-data":_vm.blockData,"is-visible":_vm.isVisible,"page":_vm.page,"seen":_vm.seen}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }